import { galleryItems } from '@/mocks/homeData';

const galleryImages: Record<string, string> = {
  Ambiance:
    'https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/cdf49431c16058b09481aaeb8cb59088.png',
  'The Bar':
    'https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/793479a8954fa82cf31fe15862bc2664.png',
  'Dining Room':
    'https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/f59f8e3149c4f4896e3d8e53b234ed96.png',
  Events:
    'https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/8b20811d6dd1af7020856587e3b0a111.png',
};

export default function Gallery() {
  return (
    <section id="gallery" className="bg-background-100">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {galleryItems.map((item) => (
          <div
            key={item.label}
            className={`relative overflow-hidden group rounded-lg ${
              item.size === 'large' ? 'col-span-2 row-span-2 aspect-[4/5]' : 'aspect-[4/5]'
            }`}
          >
            <div
              className="absolute inset-0 bg-cover bg-center group-hover:scale-105 transition-transform duration-700"
              style={{ backgroundImage: `url('${galleryImages[item.label]}')` }}
            ></div>
            <div className="absolute inset-0 bg-foreground-950/25"></div>
            <div className="absolute inset-x-0 bottom-0 p-4 md:p-6">
              <span className="text-xs uppercase tracking-[0.25em] text-foreground-50 border-b border-primary-500/60 pb-1">
                {item.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}